import { Component, Input, OnInit } from '@angular/core';
import { IRoomDetails } from "../../sector-stay-details.component";
import { Yii } from "libraries/interfaces/Yii";
import { LabelService } from "libraries/service/label/label.service";
import { PriceType } from "libraries/component/price/price.component";
import { XSellLocationEnum } from "../../../../../../../../../service/resources/booking/interfaces/IGetBookings";

@Component({
    selector: 'supplement-price',
    template: `
        <ng-container *ngIf="supplement?.value">
            +
            <price [value]="supplement.value" [currency]="supplement.currency" [type]="priceType"></price>
            {{wording}}
        </ng-container>`,
})

export class SupplementPriceComponent implements OnInit {
    @Input()
    public supplement: IRoomDetails;

    public wording: string;

    public priceType: PriceType.default;

    constructor(
        private readonly labelService: LabelService
    ) {
    }

    public ngOnInit(): void {
        if (this.supplement) {
            if (this.supplement.xSellLocation === XSellLocationEnum.local) {
                this.wording = Yii.t('wui-shared-js', "à payer sur place");
            }
        }
    }
}
